import React from 'react'
import { Controller, FieldErrors } from 'react-hook-form'
import useFormField from '../../../hooks/useFormField'
import Dropzone, { type DropzoneProps } from './Dropzone'
import { type RFHControl } from '../../../types'

export type DropzoneFieldProps = {
	name: string
	control?: RFHControl
	errors?: FieldErrors | string[]
	helperText?: string
} & DropzoneProps

const DropzoneField = ({
	name,
	control,
	errors,
	helperText,
	onDropAccepted,
	...rest
}: DropzoneFieldProps) => {
	const { getError } = useFormField()
	const error = getError(name, errors)

	if (!control) {
		return <Dropzone error={error} {...rest} />
	}

	return (
		<Controller
			name={name}
			control={control}
			render={({ field }) => (
				<Dropzone
					{...field}
					error={!!error}
					helperText={error ? error.message : helperText}
					onDropAccepted={(files) => {
						field.onChange(files)
						onDropAccepted?.(files)
					}}
					defaultValue={field.value || []}
					{...rest}
				/>
			)}
		/>
	)
}

export default DropzoneField
